import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
export type StyleProps = {};
export const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    content: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.up('md')]: {
        height: 'auto',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: theme.spacing(3)
      },
    },
    header: {
      flexGrow: 1,
      position: 'relative',
      padding: `${theme.spacing(3)}px ${theme.spacing(2)}px 0`,

      [theme.breakpoints.up('md')]: {
        maxWidth: 343,
        padding: 0,
        background: 'none',
        marginRight: 25,
        '&::before': {
          display: 'none'
        }
      },
    },
    main: {
      flexGrow: 2,
      padding: theme.spacing(2),

      [theme.breakpoints.up('md')]: {
        flexGrow: 1,
        padding: theme.spacing(5),
        backgroundColor: '#FFF',
        maxWidth: 440,
        marginLeft: 25,
        borderRadius: 32,
      },
    },
    container: {
      maxWidth: 475,
      margin: '0 auto',
      height: '100%',

      [theme.breakpoints.up('md')]: {
        maxWidth: 'none'
      },
    },
  })
);
